// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {ScrollingModule} from '@angular/cdk/scrolling';
import {CdkTableModule} from '@angular/cdk/table';
import {CdkTreeModule} from '@angular/cdk/tree';
// Translate Module
import { TranslateModule } from '@ngx-translate/core';
//Froala Module
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
// UI
import { PartialsModule } from '../../partials/partials.module';
// Auth
import { ModuleGuard } from '../../../core/auth';
// Core => Utils
import { HttpUtilsService,
	TypesUtilsService,
	InterceptService,
	LayoutUtilsService
} from '../../../core/_base/crud';
import { NgxPermissionsModule } from 'ngx-permissions';
import { NgbProgressbarModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
//Share
import { MomentDateAdapter, MAT_MOMENT_DATE_FORMATS } from '@angular/material-moment-adapter';
// Material
import {
	MatInputModule,
	MatPaginatorModule,
	MatProgressSpinnerModule,
	MatSortModule,
	MatTableModule,
	MatSelectModule,
	MatMenuModule,
	MatProgressBarModule,
	MatButtonModule,
	MatCheckboxModule,
	MatDialogModule,
	MatTabsModule,
	MatNativeDateModule,
	MatCardModule,
	MatRadioModule,
	MatIconModule,
	MatDatepickerModule,
	MatAutocompleteModule,
	MAT_DIALOG_DEFAULT_OPTIONS,
	MatSnackBarModule,
	MatTooltipModule,
	MatChipsModule,
	MAT_DATE_LOCALE,
	DateAdapter,
	MAT_DATE_FORMATS
} from '@angular/material';
import { PopoverModule } from 'ngx-smart-popover';
import { NFCModule } from '../nfc/NFC.module';
import { MY_FORMATS_EDIT } from '../nfc/datepicker';
import { DungChungService } from '../nfc/dung-chung/__services/dung-chung.service';
import { PrintTemplateComponent } from './print-template.component';
import { ChuyenKho171123PrintComponent } from './template/chuyen-kho-171123/in-chuyen-kho-171123.component';
import { ChuyenKhoNoiBo280724PrintComponent } from './template/chuyen-kho-noi-bo-280724/in-chuyen-kho-noi-bo-280724.component';
import { NgxPrintModule } from 'ngx-print';
import { DeNghiChuyenKho171123PrintComponent } from './template/de-nghi-chuyen-kho-171123/in-de-nghi-chuyen-kho-171123.component';
import { DeNghiNhapKho171123PrintComponent } from './template/de-nghi-nhap-kho-171123/in-de-nghi-nhap-kho-171123.component';
import { DNXKNoiBo171123PrintComponent } from './template/de-nghi-xuat-kho-171123/noi-bo/dnxk-noi-bo-171123.component';
import { NhapKhoTuNcc171123PrintComponent } from './template/nhap-kho-tu-ncc-171123/in-nhap-kho-tu-ncc-171123.component';
import { NhapKhoTuYeuCau171123PrintComponent } from './template/nhap-kho-tu-yeu-cau-171123/in-nhap-kho-tu-yeu-cau-171123.component';
import { DNXKBanHang171123PrintComponent } from './template/de-nghi-xuat-kho-171123/ban-hang/dnxk-ban-hang-171123.component';
import { XKTraNCC171123PrintComponent } from './template/xuat-kho-171123/tra-ncc/xuat-kho-tra-ncc-171123.component';
import { XKKhachHang171123PrintComponent } from './template/xuat-kho-171123/ra-ngoai-khach-hang/xuat-kho-khach-hang-171123.component';
import { XKNoiBo171123PrintComponent } from './template/xuat-kho-171123/noi-bo/xuat-kho-noi-bo-171123.component';
import { XKBanHang171123PrintComponent } from './template/xuat-kho-171123/ban-hang/xuat-kho-ban-hang-171123.component';
import { DoiTraHangPrintComponent } from './template/doi-tra-hang/in-doi-tra-hang.component';
import { DeNghiMuaHang } from '../nfc/mua-hang/de-nghi-mua-hang/de-nghi-mua-hang-model/de-nghi-mua-hang.model';
import { DeNghiMuaHangTheoNhuCauPrintComponent } from './template/de-nghi-mua-hang-theo-nhu-cau/in-de-nghi-mua-hang-theo-nhu-cau.component';
@NgModule({
    imports: [
		MatDialogModule,
		CommonModule,
		HttpClientModule,
		PartialsModule,
		NgxPermissionsModule.forChild(),
		NgxMatSelectSearchModule,
		FormsModule,
		ReactiveFormsModule,
		TranslateModule.forChild(),
		MatButtonModule,
		MatMenuModule,
		MatSelectModule,
        MatInputModule,
		MatTableModule,
		MatAutocompleteModule,
		MatRadioModule,
		MatIconModule,
		NgxPrintModule,
		MatCheckboxModule 
	],
	providers: [
		ModuleGuard,
		InterceptService,
      	{
        	provide: HTTP_INTERCEPTORS,
       	 	useClass: InterceptService,
        	multi: true
      	},
		{
			provide: MAT_DIALOG_DEFAULT_OPTIONS,
			useValue: {
				hasBackdrop: true,
				panelClass: 'kt-mat-dialog-container__wrapper',
				height: 'auto',
				width: '900px'
			}
		},
		{ provide: MAT_DATE_LOCALE, useValue: 'vi' },
		{ provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
		{ provide: MAT_DATE_FORMATS, useValue: MY_FORMATS_EDIT },
		TypesUtilsService,
		LayoutUtilsService,
		HttpUtilsService
		],
    declarations: [
		//PrintTemplateComponent,
		ChuyenKho171123PrintComponent,
		DeNghiChuyenKho171123PrintComponent,
		DeNghiNhapKho171123PrintComponent,
		NhapKhoTuNcc171123PrintComponent,
		NhapKhoTuYeuCau171123PrintComponent,
		DNXKNoiBo171123PrintComponent,
		DNXKBanHang171123PrintComponent,
		XKTraNCC171123PrintComponent,
		XKKhachHang171123PrintComponent,
		XKNoiBo171123PrintComponent,
		XKBanHang171123PrintComponent,
		ChuyenKhoNoiBo280724PrintComponent,
		DoiTraHangPrintComponent,
		DeNghiMuaHangTheoNhuCauPrintComponent
	],
    bootstrap: [
		//PrintTemplateComponent,
		ChuyenKho171123PrintComponent,
		ChuyenKhoNoiBo280724PrintComponent,
		DeNghiChuyenKho171123PrintComponent,
		DeNghiNhapKho171123PrintComponent,
		NhapKhoTuNcc171123PrintComponent,
		NhapKhoTuYeuCau171123PrintComponent,
		DNXKNoiBo171123PrintComponent,
		DNXKBanHang171123PrintComponent,
		XKTraNCC171123PrintComponent,
		XKKhachHang171123PrintComponent,
		XKNoiBo171123PrintComponent,
		XKBanHang171123PrintComponent,
		DoiTraHangPrintComponent,
		DeNghiMuaHangTheoNhuCauPrintComponent
	],
    exports:  [
		 //PrintTemplateComponent,
		 ChuyenKho171123PrintComponent,
		 ChuyenKhoNoiBo280724PrintComponent,
		 DeNghiChuyenKho171123PrintComponent,
		 DeNghiNhapKho171123PrintComponent,
		 NhapKhoTuNcc171123PrintComponent,
		 NhapKhoTuYeuCau171123PrintComponent,
		 DNXKNoiBo171123PrintComponent,
		 DNXKBanHang171123PrintComponent,
		 XKTraNCC171123PrintComponent,
		 XKKhachHang171123PrintComponent,
		 XKNoiBo171123PrintComponent,
		 XKBanHang171123PrintComponent,
		 DoiTraHangPrintComponent,
		 DeNghiMuaHangTheoNhuCauPrintComponent
	]
})
export class PrintTemplateModule { }

